import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nica-header',
  templateUrl: './nica-header.component.html',
  styleUrls: ['./nica-header.component.css']
})
export class NicaHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
